import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);
  const router = inject(Router)
  return next(req).pipe(
    catchError(err => {
      if (err instanceof HttpErrorResponse) {
        switch (err.status) {
          case 400:
            if (err.error.errors) {
              const modalStateErrors = [];
              for (const key in err.error.errors) {
                if (err.error.errors[key]) {
                  modalStateErrors.push(err.error.errors[key])
                }
              }
              throw modalStateErrors.flat();
            } else if (Array.isArray(err.error)) {
              const modalStateErrors = [];
              for (const key in err.error) {
                if (err.error[key]) {
                  modalStateErrors.push(err.error[key])
                }
              }
              throw modalStateErrors.flat();
            } else if (typeof (err.error) === 'object') {
              toastr.error(err.error, "Bad Request");
            } else {
              toastr.error(err.error, "Bad Request");
            }
            break;
          case 403:
            throw err;
          case 404:
            throw err;
          case 401:
            toastr.error(err.statusText, err.status.toString());
            break;
          default:
            toastr.error('Something unexpected went wrong');
            console.log(err);
            break;
        }
      }
      throw err;
    })
  );
};
